// T3-B sponsored motif (PR 4, 2026-05-07): sponsored_campaigns 管理用 MobX store。
// T3-B (PR 7-CMS, 2026-05-07): 効果計測 stats() flow を追加。

import { SponsoredCampaignApi, SponsoredCampaignStatsApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class SponsoredCampaignStore extends BaseStore {
    campaigns: any[] = [];
    campaign: any = null;
    total: number = 0;
    // T3-B (PR 7-CMS): 個別 campaign の効果計測データ。stats sheet 描画用。
    stats: any = null;
    api: SponsoredCampaignApi;
    statsApi: SponsoredCampaignStatsApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            campaigns: observable,
            campaign: observable,
            total: observable,
            stats: observable,
            list: flow.bound,
            getById: flow.bound,
            create: flow.bound,
            update: flow.bound,
            changeStatus: flow.bound,
            remove: flow.bound,
            getStats: flow.bound
        });
        this.api = new SponsoredCampaignApi();
        this.statsApi = new SponsoredCampaignStatsApi();
    }

    *getStats(payload: { id: string | number, from?: string, to?: string }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.statsApi, this.statsApi.getCampaignStats, payload);
            if (res?.ok) {
                this.stats = res.data;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *list(searchParams?: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.list, searchParams);
            if (res?.ok) {
                this.campaigns = res.data?.items ?? [];
                this.total = res.data?.total ?? 0;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *getById(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getById, id);
            if (res?.ok) {
                this.campaign = res.data;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *create(payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.create, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *update(payload: { id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.update, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *changeStatus(payload: { id: string | number, status: string }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.changeStatus, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *remove(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.remove, id);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }
}
